import { defineStyle, defineStyleConfig } from '@chakra-ui/react';

const filterSearch = defineStyle({
  field: {
    color: 'yGray.900',
    border: '1px solid',
    borderColor: 'yGray.200',
    bg: 'transparent',
    fontSize: 'sm',
    _placeholder: {
      color: 'yGray.400',
    },
    _hover: {
      borderColor: 'yGray.400',
    },
    _focus: {
      border: '2px solid',
      borderColor: 'yPrimary.600',
    },
  },
});

export const inputTheme = defineStyleConfig({
  baseStyle: {
    field: {
      borderRadius: '6px',
    },
  },
  sizes: {
    medium: {
      field: {
        h: 12,
        px: 4,
        fontSize: 'sm',
      },
    },
  },
  variants: {
    filterSearch,
  },
});
